import { render, staticRenderFns } from "./PermissionRoles.vue?vue&type=template&id=d0bd5b10&scoped=true&"
import script from "./PermissionRoles.vue?vue&type=script&lang=js&"
export * from "./PermissionRoles.vue?vue&type=script&lang=js&"
import style0 from "./PermissionRoles.vue?vue&type=style&index=0&id=d0bd5b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bd5b10",
  null
  
)

export default component.exports